import React, { useEffect, useRef, useState } from "react";
import { Offcanvas, OverlayTrigger, Popover } from "react-bootstrap";
import Select from "react-select";
import { getProductDetailListingRefresh } from "../../../actions/dashboardAction";
import { decode, imageUrl, numberFormat } from "../../../actions/miscAction";
import {
  fileDelete,
  getCountries,
  getStates,
  imageDelete,
  imageUpload,
  markAsPrimary,
  postListing,
  privateFileUpload,
  updatePictureCaption,
} from "../../../actions/memberAction";
import Editor from "../../common/editor/editor";
import { Scrib } from "../../common/editImage/scribble";
import Edit from "../../common/editImage/editImageNew";
import DeleteModal from "../../common/deleteModal";
import LoadingBar from "react-top-loading-bar";
import AlertError from "../../common/alertError";
import { toast } from "react-toastify";
import AlertSuccess from "../../common/alertSuccess";
import _, { capitalize } from "lodash";
import Amplify, { Auth, Storage } from "aws-amplify";
import { v4 as uuidv4 } from "uuid";
import { dataURLtoFile } from "../../common/editImage/dataURLtoFile";
import Joi from "joi";
import { validateErrorMessage } from "../../common/validation";
import moment from "moment";
import HTMLReactParser from "html-react-parser";
import DateFormat from "../../common/dateFormat";
import { Link } from "gatsby";

const closeIcon = imageUrl("close-icon.svg");
const uploadImg = imageUrl("upload-img.jpg");
const pdfIcon = imageUrl("pdf-doc-img.svg");
const featured = imageUrl("uib-icon-1.svg");
const yellowFeatured = imageUrl("yellow-star-icon.svg");
const tag = imageUrl("uib-icon-2.svg");
const crop = imageUrl("uib-icon-3.svg");
const rotate = imageUrl("uib-icon-4.svg");
const scribble = imageUrl("uib-icon-5.svg");
const deleteIcon = imageUrl("uib-icon-6.svg");
const save = imageUrl("save.svg");
const cropNew = imageUrl("crop-new.svg");
const success = imageUrl("success-icon.png");

const conditionOptions = [
  { name: "New", value: "New" },
  { name: "New Surplus", value: "New Surplus" },
  { name: "Used", value: "Used" },
  { name: "Damaged", value: "Damaged" },
  { name: "Scrap", value: "Scrap" },

  { name: "Factory New", value: "Factory New" },
  { name: "Overhauled", value: "Overhauled" },
  { name: "Serviceable", value: "Serviceable" },
  { name: "As Removed", value: "As Removed" },
  { name: "Repairable", value: "Repairable" },
  { name: "Repaired", value: "Repaired" },
  { name: "Inspected", value: "Inspected" },
  { name: "Core", value: "Core" },

  { name: "Beyond Economical Repair", value: "Beyond Economical Repair" },
  { name: "Rebuilt", value: "Rebuilt" },
  { name: "Modified", value: "Modified" },

  { name: "Tested", value: "Tested" },
  { name: "Unserviceable", value: "Unserviceable" },

  { name: "Disposal", value: "Disposal" },
  { name: "Disposal/Free", value: "Disposal/Free" },
  { name: "Unused", value: "Unused" },

  { name: "Others", value: "Others" },
];

const customStyles = {
  indicatorSeparator: (styles) => ({ display: "none" }),
  option: (provided, state) => ({
    ...provided,
    "&:hover": {
      backgroundColor: "#47ad1d",
      color: "#fff",
    },
    display: "-webkit-box",
    WebkitLineClamp: 3,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    color: state.isSelected ? "#fff" : "black",
    backgroundColor: state.isSelected ? "#47ad1d" : provided.backgroundColor,
    maxHeight: "84px",
    //backgroundColor: state.isSelected ? "rgb(95, 50, 187, 10%)" : "white",
  }),
  control: (base, state) => ({
    ...base,
    height: 42,
    minHeight: 42,
    borderColor: state.isFocused ? "#47AD1D" : "#e4e4e4",
    boxShadow: state.isFocused ? "0 0 0 0.5px #47AD1D" : "0",
    border: state.isHovered ? "0" : "1px solid #e4e4e4",

    "&:hover": {
      borderColor: state.isFocused ? "#47AD1D" : "0",
      boxShadow: state.isFocused ? "0 0 0 0.5px #47AD1D" : "0",
    },
    // "&:focus": {
    //   borderColor: "#47AD1D",
    //   boxShadow: "0 0 0 0.5px #47AD1D"

    // },
  }),
  multiValueRemove: (base, state) => ({
    ...base,
    "&:hover": {
      backgroundColor: "rgb(95, 50, 187, 10%)",
      color: "#6119c0",
    },
  }),
};

const CreateListing = ({ ...props }) => {
  const ref = useRef(null);
  const scribbleRef = useRef(null);
  const childRef = useRef(null);
  const inputRef = useRef(null);

  const [tab, setTab] = useState(1);
  const [allCountries, setAllCountries] = useState([]);
  const [allStates, setAllStates] = useState([]);
  const [otherCondition, setOtherCondition] = useState("");
  const [error, setError] = useState({});
  const [deleteModal, setDeleteModal] = useState(false);
  const [loadingUpdate, setLoadingUpdate] = useState(false);
  const [selectedMedia, setSelectedMedia] = useState(null);
  const [detail, setDetail] = useState({
    title: "",
    details: "",
    condition: "",
    c_name: "",
    c_company: "",
    c_phone: "",
    c_fax: "",
    c_email: "",
    address_1: "",
    city: "",
    zip: "",
    state_id: null,
    country_id: null,
    special_instr: "",
    price_1001: "",
    price_1002: "",
    price_1003: "",
    price_1004: "",
    seller_reserve: "",
    due_date: "",
    conditionType: null,
    quantity: "",
    unit: "",
    images: [],
    documents: [],
  });

  //Photos
  const [loadingMedia, setLoadingMedia] = useState(false);
  const [loadingDocs, setLoadingDocs] = useState(false);
  const [selectedUploadMedia, setSelectedUploadMedia] = useState({ img: [], docs: [] });
  const [progress, setProgress] = useState("");
  const [fileType, setFileType] = useState(".pdf");
  const [docTitle, setDocTitle] = useState("");
  const [optionType, setOptionType] = useState("");
  const [optionTypeId, setOptionTypeId] = useState("");
  const [title, setTitle] = useState("");
  const [selectedImage, setSelectedImage] = useState(null);
  const [editedFile, setEditedFile] = useState(null);
  const [auctionId, setAuctionId] = useState("");

  const schema = Joi.object({
    title: Joi.string()
      .trim()
      .required()
      .error((error) => validateErrorMessage(error)),
    details: Joi.string()
      .trim()
      .required()
      .label("Description")
      .error((error) => validateErrorMessage(error)),
    condition: Joi.string().error((error) => validateErrorMessage(error)),
    quantity: Joi.number().error((error) => validateErrorMessage(error)),
    unit: Joi.string().error((error) => validateErrorMessage(error)),
    c_name: Joi.string().error((error) => validateErrorMessage(error)),
    c_company: Joi.string().error((error) => validateErrorMessage(error)),
    c_phone: Joi.any(),
    c_fax: Joi.any(),
    c_email: Joi.string().error((error) => validateErrorMessage(error)),
    address_1: Joi.string().error((error) => validateErrorMessage(error)),
    city: Joi.string().error((error) => validateErrorMessage(error)),
    zip: Joi.any(),
    state_id: Joi.object().error((error) => validateErrorMessage(error)),
    country_id: Joi.object().error((error) => validateErrorMessage(error)),
    conditionType: Joi.object().error((error) => validateErrorMessage(error)),
    special_instr: Joi.string().error((error) => validateErrorMessage(error)),
    price_1001: Joi.number().error((error) => validateErrorMessage(error)),
    price_1002: Joi.number().error((error) => validateErrorMessage(error)),
    price_1003: Joi.number().error((error) => validateErrorMessage(error)),
    price_1004: Joi.number().error((error) => validateErrorMessage(error)),
    seller_reserve: Joi.string().error((error) => validateErrorMessage(error)),
    due_date: Joi.string().error((error) => validateErrorMessage(error)),
    images: Joi.array().error((error) => validateErrorMessage(error)),
    documents: Joi.array().error((error) => validateErrorMessage(error)),
    country: Joi.object().error((error) => validateErrorMessage(error)),
    state: Joi.object().error((error) => validateErrorMessage(error)),
  });
  const validate = (type = false) => {
    const error = schema.validate(
      _.pickBy(detail, _.identity),
      type
        ? {
            abortEarly: type,
          }
        : {},
    );
    if (error.error && error.error.details) {
      const errors = {};
      error.error.details.forEach((element) => {
        errors[element.context.key] = element.message;
      });
      setError(errors);
      document.querySelector("#offcanvascreate .offcanvas-body").scrollTo({
        top: 0,
        behavior: "smooth",
      });
      return false;
    }
    setError("");
    return true;
  };

  useEffect(() => {
    setTab(1);
    setDetail({});
    setOptionType(props?.type ? props?.type : "");
    setSelectedImage(props?.image ? props?.image : null);
  }, []);

  useEffect(() => {
    if (typeof window !== "undefined" && localStorage.getItem("member")) {
      getCountries((res) => {
        if (res && res.status == 200) {
          setAllCountries(res.data);
        }
      });

      getStates((res) => {
        if (res && res.status == 200) {
          setAllStates(res.data);
        }
      });
    }
  }, []);

  const onchange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    const data = { ...detail };
    data[name] = value;
    setDetail(data);
  };

  const toggleDeleteModal = () => {
    setDeleteModal(!deleteModal);
  };

  const handleDeleteImg = () => {
    setLoadingMedia(true);
    ref?.current?.continuousStart();
    imageDelete(selectedMedia?.picture_id, (res) => {
      if (res.status === 200) {
        getProductDetailListingRefresh(auctionId, (res2) => {
          setLoadingMedia(false);

          toggleDeleteModal();
          if (res2.status === 200) {
            const data = { ...detail };
            data.images = res2.data.pics;
            setDetail(data);
          }
          toast(<AlertSuccess message="Information Saved" />);
          ref?.current?.complete();
        });
      } else {
        toast(<AlertError message={res?.response?.data?.message || "Something went wrong"} />);
      }
    });
  };
  const handlePrimayImg = (id) => {
    setLoadingMedia(true);
    ref?.current?.continuousStart();
    const payload = {
      picture_id: id,
    };
    markAsPrimary(auctionId, payload, (res) => {
      if (res.status === 200) {
        getProductDetailListingRefresh(auctionId, (res2) => {
          if (res2.status === 200) {
            const data = { ...detail };
            data.images = res2.data.pics;
            setDetail(data);

            setLoadingMedia(false);
            ref?.current?.complete();
          }
        });
      } else {
        toast(<AlertError message={res?.response?.data?.message || "Something went wrong"} />);
      }
    });
  };

  const handleSaveTitle = () => {
    setLoadingMedia(true);
    ref?.current?.continuousStart();
    const payload = {
      picture_id: optionTypeId,
      caption: title,
    };
    updatePictureCaption(auctionId, payload, (res) => {
      getProductDetailListingRefresh(auctionId, (res2) => {
        setLoadingMedia(false);
        if (res2.status === 200) {
          const data = { ...detail };
          data.images = res2.data.pics;
          setDetail(data);

          setOptionType("");
          ref?.current?.complete();
        } else {
          toast(<AlertError message={res2?.response?.data?.message || "Something went wrong"} />);
        }
      });
    });
  };
  const handleDeleteDoc = () => {
    setLoadingMedia(true);
    ref?.current?.continuousStart();
    fileDelete(selectedMedia?.doc_id, () => {
      getProductDetailListingRefresh(auctionId, (res2) => {
        setLoadingMedia(false);
        toggleDeleteModal();
        if (res2.status === 200) {
          const data = { ...detail };
          data.documents = res2.data.privateDocuments;
          setDetail(data);
        } else {
          toast(<AlertError message={res2?.response?.data?.message} />);
        }
        ref?.current?.complete();
      });
    });
  };

  const doSubmit = () => {
    if (!validate()) return;
    ref?.current?.continuousStart();
    setLoadingUpdate(true);
    const data = { ...detail };

    const payload = {
      title: data.title,
      details: data.details,
      condition: data.condition,
      quantity: data.quantity,
      unit: data.unit,
      c_name: data.c_name,
      c_company: data.c_company,
      c_phone: data.c_phone,
      c_fax: data.c_fax,
      c_email: data.c_email,
      address_1: data.address_1,
      city: data.city,
      zip: data.zip,
      state_id: !_.isEmpty(data.state_id) ? data.state_id.value.toString() : "",
      country_id: !_.isEmpty(data.country_id) ? data.country_id.value.toString() : "",
      special_instr: data.special_instr,
      price_1002: data.price_1002,
      price_1003: data.price_1003,
      price_1004: data.price_1004,
      seller_reserve: data.seller_reserve,
      due_date: moment(data.due_date).format("YYYY-MM-DDTHH:mm"),
      conditionType: data?.conditionType?.name
        ? data?.conditionType?.name == "Others"
          ? otherCondition
          : data?.conditionType?.name
        : "",
    };

    var params = _.pickBy(payload, function (value, key) {
      return !(value === undefined || value === "" || value == null || value == {});
    });

    postListing(
      {
        ...params,
        seller_reserve: data.price_1001 ? data.price_1001 : 0,
        for_donation: false,
        seller_agent: 1,
      },
      (res) => {
        ref?.current?.complete();
        setLoadingUpdate(false);
        if (res.status === 200) {
          setAuctionId(res.data.data.output.auction_id);
          payload.auction_id = res.data.data.output.auction_id;
          props?.setSelectedId(payload);
          const dataLayer = window.dataLayer || [];
          dataLayer.push({
            event: "post_listing",
            postListingAction: "continue",
            postListingStep: "general_info",
          });
          setTab(2);
          document.querySelector("#offcanvascreate .offcanvas-body").scrollTo({
            top: 0,
            behavior: "smooth",
          });
        } else {
          toast(<AlertError message={res.response && res.response.data && res.response.data.message} />);
        }
      },
    );
  };

  const validateTitle = () => {
    const errors = { ...error };
    if (docTitle && docTitle.trim().length > 0) {
      errors.docTitle = "";
    }

    if (selectedUploadMedia?.docs?.length > 0) {
      errors.document = "";
    }

    if (selectedUploadMedia?.docs?.length == 0) {
      errors.document = <p className="val-error-text">Document is required</p>;
    }

    if (!docTitle || !docTitle?.trim() || !docTitle?.trim()?.length) {
      errors.docTitle = <p className="val-error-text">Title is required</p>;
    }
    const isEmpty = Object.values(error).every((x) => x === null || x === "");

    if (!isEmpty) {
      setError(errors);
      return true;
    } else {
      setError(errors);
      return false;
    }
  };

  const removeUploaded = (res) => {
    const value = { ...selectedUploadMedia };
    const a = value?.img?.filter((item) => item.name !== res.name);
    value.img = a;
    setSelectedUploadMedia(value);
  };

  const onSelectMedia = (e, type) => {
    const imageContainer = [];
    for (let i = 0; i < e.target.files.length; i++) {
      const fSize = Math.round(e.target.files[i].size / 1048576);
      const fType = e.target.files[i].type;
      if (fSize > 25) {
        toast(<AlertError message="File size exceeds maximum allowable size. Maximum allowable size is 25MB." />);
        return;
      } else if (
        type === "doc"
          ? ![
              "application/pdf",
              "text/csv",
              "application/vnd.ms-excel",
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              "application/msword",
              "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            ].includes(fType)
          : !["image/jpeg", "image/jpg", "image/png"].includes(fType)
      ) {
        toast(
          <AlertError
            message={
              type === "doc"
                ? "File is not of correct format and hence cannot be uploaded. Valid document formats are pdf, xlsx, xls, doc, docx and csv."
                : "File is not of correct format and hence cannot be uploaded. Valid image formats are  JPG, JPEG, PNG ."
            }
          />,
        );
        return;
      } else {
        imageContainer.push(e.target.files[i]);
      }
    }
    const value = { ...selectedUploadMedia };
    if (type === "doc") {
      value.docs = [...imageContainer, ...selectedUploadMedia?.docs];
    } else {
      value.img = [...imageContainer, ...selectedUploadMedia?.img];
    }

    setSelectedUploadMedia(value);
  };

  const onUploadMedia = async (type) => {
    if (type === "doc") {
      setLoadingDocs(true);
    } else {
      setLoadingMedia(true);
    }
    setProgress("uploading");
    ref?.current?.continuousStart();

    const selectedMedias = type === "doc" ? selectedUploadMedia?.docs : selectedUploadMedia?.img;

    try {
      // Validate all files first
      for (const media of selectedMedias) {
        const fSize = Math.round(media.size / 1048576);
        const fType = media.type;

        if (fSize > 25) {
          toast(<AlertError message="File size exceeds maximum allowable size. Maximum allowable size is 25MB." />);
          setLoadingMedia(false);
          setLoadingDocs(false);
          setProgress("failed");
          ref?.current?.complete();
          return;
        }

        const validDocTypes = [
          "application/pdf",
          "text/csv",
          "application/vnd.ms-excel",
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          "application/msword",
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        ];
        const validImageTypes = ["image/jpeg", "image/jpg", "image/png"];

        if (type === "doc" ? !validDocTypes.includes(fType) : !validImageTypes.includes(fType)) {
          toast(
            <AlertError
              message={
                type === "doc"
                  ? "File is not of correct format and hence cannot be uploaded. Valid document formats are pdf, xlsx, xls, doc, docx and csv."
                  : "File is not of correct format and hence cannot be uploaded. Valid image formats are  JPG, JPEG, PNG ."
              }
            />,
          );
          setLoadingMedia(false);
          setLoadingDocs(false);
          setProgress("failed");
          ref?.current?.complete();
          return;
        }
      }

      // Process all files in parallel
      await Promise.all(
        selectedMedias.map(async (media) => {
          const ext = media.name.split(".").pop();
          ref.current?.continuousStart();

          const fileName = "newSalvex/" + uuidv4() + "." + ext;
          const result = await Storage.put(fileName, media, {
            completeCallback: (event) => {},
            progressCallback: (progress) => {},
            errorCallback: (err) => {},
          });

          if (type === "doc") {
            const payload = {
              image: "public/" + result.key,
              name: docTitle,
            };

            const res = await new Promise((resolve) => {
              privateFileUpload(payload, auctionId, resolve);
            });

            if (res?.status === 200) {
              const res2 = await new Promise((resolve) => {
                getProductDetailListingRefresh(auctionId, resolve);
              });

              if (res2.status === 200) {
                const data = { ...detail };
                data.documents = res2.data.privateDocuments;
                setDocTitle("");
                setDetail(data);
              } else {
                toast(<AlertError message={res2.response?.data?.message || "Something went wrong"} />);
              }
            } else {
              toast(<AlertError message={res?.response?.data?.message || "Something went wrong"} />);
              setProgress("failed");
              setLoadingDocs(false);
              ref.current?.complete();
              throw new Error("Document upload failed");
            }
          } else {
            const payload = {
              image: "public/" + result.key,
            };

            const res = await new Promise((resolve) => {
              imageUpload(payload, auctionId, resolve);
            });

            if (res?.status === 200) {
              const res2 = await new Promise((resolve) => {
                getProductDetailListingRefresh(auctionId, resolve);
              });

              if (res2.status === 200) {
                const data = { ...detail };
                data.images = res2.data.pics;
                setDetail(data);
              } else {
                toast(<AlertError message={res2?.response?.data?.message || "Something went wrong"} />);
              }
            } else {
              toast(<AlertError message={res.response.data.message || "Something went wrong"} />);
              setProgress("failed");
              setLoadingMedia(false);
              ref.current?.complete();
              throw new Error("Image upload failed");
            }
          }
        }),
      );

      // All uploads completed successfully
      setProgress("completed");
      setSelectedUploadMedia((prev) => ({
        ...prev,
        [type === "doc" ? "docs" : "img"]: [],
      }));

      if (type === "doc") {
        setLoadingDocs(false);
        toast(<AlertSuccess message="Information Saved" />);
      } else {
        setLoadingMedia(false);
      }

      ref.current?.complete();
    } catch (error) {
      // Error handling is mostly done in individual catch blocks above
      // This catch is for any unexpected errors
      console.error("Upload error:", error);
      setProgress("failed");
      setLoadingMedia(false);
      setLoadingDocs(false);
      ref.current?.complete();
    }
  };
  const handleEditImageUploader = async () => {
    if (editedFile?.length > 0) {
      setLoadingMedia(true);
      setProgress("uploading");
      ref.current && ref.current.continuousStart();
      const file = dataURLtoFile(editedFile, "savlex");
      const fileName = "newSalvex/" + uuidv4() + ".jpeg";
      Storage.put(fileName, file, {
        completeCallback: (event) => {},
        progressCallback: (progress) => {},
        errorCallback: (err) => {},
      }).then((result) => {
        const payload = {
          image: "public/" + result.key,
          picture_id: selectedImage.picture_id,
        };

        imageUpload(payload, auctionId, (res) => {
          if (res?.status === 200) {
            getProductDetailListingRefresh(auctionId, (res2) => {
              if (res2.status === 200) {
                const data = { ...detail };
                data.images = res2.data.pics;
                setDetail(data);
                setLoadingMedia(false);
                ref.current && ref.current.complete();
              } else {
                toast(<AlertError message={res2?.response?.data?.message || "Something went wrong"} />);
              }
              setProgress("completed");
              setOptionType("");
              setEditedFile([]);

              setSelectedUploadMedia((prev) => ({
                ...prev,
                img: [],
              }));
            });
          } else {
            toast(<AlertError message={res.response.data.message || "Something went wrong"} />);
            setProgress("failed");
            setLoadingMedia(false);
            ref.current && ref.current.complete();
          }
        });
      });
    }
  };

  useEffect(() => {
    if (optionType === "scribble" && editedFile.length > 0) {
      ref?.current?.continuousStart();
      handleEditImageUploader();
    }
  }, [editedFile]);

  useEffect(() => {
    const offcanvas = document.querySelector(".offcanvas");
    if (offcanvas) {
      offcanvas.removeAttribute("tabindex");
    }
    setTimeout(() => {
      inputRef?.current?.focus();
    }, 100);
  }, [optionType]);

  useEffect(() => {
    if (tab === 3) {
      getProductDetailListingRefresh(auctionId, (res2) => {
        if (res2?.status === 200) {
          const data = { ...detail };
          data.images = res2.data.pics;
          data.documents = res2.data.privateDocuments;
          setDetail(data);
        } else {
          toast(<AlertError message={res2?.response?.data?.message || "Something went wrong"} />);
        }
      });
    }
  }, [tab]);

  //Popover
  const popoverClick =
    optionType === "edit" ? (
      <Popover
        className="popover"
        id="popover-positioned-top"
        title="Popover top"
        bsPrefix=" popover custom-popover border-0 rounded-0"
      >
        <Popover.Body>
          <div class="d-flex align-content-center" onClick={(e) => e.stopPropagation()}>
            <input
              ref={inputRef}
              type="text"
              placeholder="Enter Image Title"
              className="form-control flex-grow-1"
              value={title}
              onClick={(e) => e.stopPropagation()}
              onChange={(e) => setTitle(e.target.value)}
            />
            <button
              type="button"
              class={`addClickButton-brand d-flex align-items-center justify-content-center ${
                loadingMedia || !title ? "btn-disabled " : ""
              }`}
              onClick={(e) => {
                e.stopPropagation();
                handleSaveTitle();
                // setShowBackdrop(false);
              }}
            >
              <img src={save} alt="" />
            </button>
          </div>
        </Popover.Body>
      </Popover>
    ) : (
      <Popover></Popover>
    );

  return (
    <>
      <LoadingBar height={5} color="var(--brand-color2)" ref={ref} />

      <div class="offcanvas-dashboard-tab cn-top offcanvas-create-listing">
        {tab <= 3 && (
          <div class="step-container ">
            <div class="sc-list-box">
              <ul class="step-list d-flex">
                <li class={tab >= 1 && "active"}>
                  <div class="step-box" style={{ cursor: "pointer" }}>
                    <h5>1</h5>
                    <h6>General Info</h6>
                  </div>
                </li>
                <li class={tab >= 2 && "active"}>
                  <div class="step-box" style={{ cursor: "pointer" }}>
                    <h5>2</h5>
                    <h6>Media</h6>
                  </div>
                </li>
                <li class={tab >= 3 && "active"}>
                  <div class="step-box" style={{ cursor: "pointer" }}>
                    <h5>3</h5>
                    <h6>Review Post</h6>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        )}
        <div class="tab-content" id="nav-tabContent">
          {tab === 1 && (
            <div class={`tab-pane fade show active`} id="nav-odt1" role="tabpanel" aria-labelledby="nav-odt1-tab">
              <div class="offcanvas-dashboard-body">
                <h5 className="mb-34">Product Information</h5>
                <form class="row g-4">
                  <div class="col-12">
                    <label for="title" class="form-label">
                      Title of Item
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      id="title"
                      name="title"
                      onChange={onchange}
                      value={detail?.title}
                    />
                    {error?.title && <p className="error">{error?.title}</p>}
                  </div>
                  <div class="col-md-6">
                    <label for="quantity" class="form-label">
                      Quantity
                    </label>
                    <input
                      type="number"
                      class="form-control"
                      id="quantity"
                      name="quantity"
                      onChange={onchange}
                      value={detail?.quantity}
                    />
                    {error?.quantity && <p className="error">{error?.quantity}</p>}
                  </div>
                  <div class="col-md-6">
                    <label for="unit" class="form-label">
                      Unit
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      id="unit"
                      name="unit"
                      onChange={onchange}
                      value={detail?.unit}
                    />
                    {error?.unit && <p className="error">{error?.unit}</p>}
                  </div>
                  <div class="col-md-12">
                    <label for="description" class="form-label">
                      Description
                      <span>
                        Please provide a detailed description of the item you are selling. If you do not have a detailed
                        description or you have submitted the information via email, please provide a brief description
                        of the item.
                      </span>
                    </label>

                    <Editor
                      name="task"
                      className={"form-control"}
                      onChange={(data) => {
                        const value = { ...detail };
                        value.details = data;
                        setDetail(value);
                      }}
                      editorLoaded={props?.isEditorLoaded}
                      value={detail?.details ? detail?.details : ""}
                    />

                    {error?.details && <p className="error">{error?.details}</p>}
                  </div>
                  <div class="col-md-12">
                    <label class="form-label" for="conditionType">
                      Condition
                    </label>
                    <Select
                      value={detail?.conditionType}
                      className="basic-single"
                      classNamePrefix="select-search"
                      getOptionLabel={(option) => option.name}
                      getOptionValue={(option) => option.value}
                      name="conditiontype"
                      options={conditionOptions}
                      placeholder={""}
                      styles={customStyles}
                      onChange={(a) => {
                        const value = { ...detail };
                        value.conditionType = a;
                        setDetail(value);
                      }}
                    />
                    {detail?.conditionType?.value == "Others" ? (
                      <div class="row" style={{ marginTop: "20px" }}>
                        <div class="col-md-6">
                          <input
                            class="form-control"
                            id="otherCondition"
                            name="otherCondition"
                            onChange={(e) => {
                              setOtherCondition(e.target.value);
                            }}
                            value={otherCondition}
                          />
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                  <div class="col-md-12">
                    <label class="form-label" name="condition">
                      Condition Description
                      <span>
                        Please provide a brief description of why the item is available, any present damage, age and how
                        long it has been stored.
                      </span>
                    </label>
                    <textarea
                      name="condition"
                      id="condition-descp-ct"
                      className={"form-control"}
                      onChange={onchange}
                      value={detail?.condition}
                    ></textarea>
                  </div>
                  <h5 className="mt-34 mb-34">Product Location</h5>
                  <div class="col-md-6 ct-mt-0">
                    <label for="c_name" class="form-label">
                      Contact
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      id="c_name"
                      name="c_name"
                      value={detail?.c_name}
                      onChange={onchange}
                    />
                  </div>
                  <div class="col-md-6 ct-mt-0">
                    <label for="c_company" class="form-label">
                      Company
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      id="c_company"
                      name="c_company"
                      value={detail?.c_company}
                      onChange={onchange}
                    />
                  </div>
                  <div class="col-md-6">
                    <label for="c_phone" class="form-label">
                      Phone
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      id="c_phone"
                      name="c_phone"
                      value={detail?.c_phone}
                      onChange={onchange}
                    />
                  </div>
                  <div class="col-md-6">
                    <label for="c_fax" class="form-label">
                      Fax
                    </label>
                    <input
                      type="number"
                      class="form-control"
                      id="c_fax"
                      name="c_fax"
                      value={detail?.c_fax}
                      onChange={onchange}
                    />
                  </div>
                  <div class="col-md-6">
                    <label for="c_email" class="form-label">
                      Email
                    </label>
                    <input
                      type="email"
                      class="form-control"
                      id="c_email"
                      name="c_email"
                      value={detail?.c_email}
                      onChange={onchange}
                    />
                  </div>
                  <div class="col-md-6">
                    <label for="address_1" class="form-label">
                      Address
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      id="address_1"
                      name="address_1"
                      value={detail?.address_1}
                      onChange={onchange}
                    />
                  </div>
                  <div class="col-md-6">
                    <label for="city" class="form-label">
                      City
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      id="city"
                      name="city"
                      value={detail?.city}
                      onChange={onchange}
                    />
                  </div>
                  <div class="col-md-6">
                    <label for="zip" class="form-label">
                      Zip
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      id="city"
                      name="zip"
                      value={detail?.zip}
                      onChange={onchange}
                    />
                  </div>
                  <div class="col-md-6">
                    <label class="form-label">Country</label>
                    <Select
                      value={detail?.country}
                      className="basic-single"
                      classNamePrefix="select-search"
                      getOptionLabel={(option) => option.name}
                      getOptionValue={(option) => option.value}
                      name="country"
                      options={[
                        {
                          label: "Popular",
                          options: [
                            { name: "United States", value: "1001" },
                            { name: "Canada", value: "1039" },
                          ],
                        },
                        {
                          label: "All",
                          options:
                            allCountries &&
                            allCountries.length > 0 &&
                            allCountries
                              .filter((op) => op.country_id != "1001" && op.country_id != "1039")
                              .map((ee) => ({
                                name: ee.description,
                                value: ee.country_id,
                              })),
                        },
                      ]}
                      placeholder={""}
                      styles={customStyles}
                      onChange={(e) => {
                        const data = { ...detail };
                        const errors = { ...error };
                        data.country = e;
                        data.state = {};
                        setDetail(data);
                        setError(errors);
                      }}
                    />
                  </div>
                  <div class="col-md-6">
                    <label class="form-label">State (if USA)</label>
                    <Select
                      value={detail?.state}
                      className="basic-single"
                      classNamePrefix="select-search"
                      getOptionLabel={(option) => option.name}
                      getOptionValue={(option) => option.value}
                      name="state"
                      options={
                        detail?.country && detail?.country && detail?.country.value != "1001"
                          ? [{ name: "International", value: "1001" }]
                          : allStates &&
                            allStates.length > 0 &&
                            allStates
                              .filter((item) => item.state_id != "1001")
                              .map((ee) => ({
                                name: ee.description,
                                value: ee.state_id,
                              }))
                      }
                      placeholder={""}
                      styles={customStyles}
                      onChange={(e) => {
                        const data = { ...detail };
                        const errors = { ...error };
                        data.state = e;
                        delete error.state;
                        setDetail(data);
                        setError(errors);
                      }}
                    />
                  </div>
                  <h5 className="mt-34 mb-34">Product Pricing and Reserve</h5>
                  <div class="col-md-6 ct-mt-0">
                    <label for="price_1003" class="form-label">
                      Wholesale Value
                    </label>
                    <div class="form-control-outer position-relative">
                      <input
                        type="text"
                        class="form-control"
                        id="price_1003"
                        name="price_1003"
                        value={detail?.price_1003}
                        onChange={onchange}
                      />
                      <div class="input-currency-tag">USD</div>
                    </div>
                  </div>
                  <div class="col-md-6 ct-mt-0">
                    <label for="price_1002" class="form-label">
                      Retail Value
                    </label>
                    <div class="form-control-outer position-relative">
                      <input
                        type="text"
                        class="form-control"
                        id="price_1002"
                        name="price_1002"
                        value={detail?.price_1002}
                        onChange={onchange}
                      />
                      <div class="input-currency-tag">USD</div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <label for="price_1004" class="form-label">
                      Claim Price
                    </label>
                    <div class="form-control-outer position-relative">
                      <input
                        type="text"
                        class="form-control"
                        id="price_1004"
                        name="price_1004"
                        value={detail?.price_1004}
                        onChange={onchange}
                      />
                      <div class="input-currency-tag">USD</div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <label for="price_1001" class="form-label">
                      Reserve Price
                    </label>
                    <div class="form-control-outer position-relative">
                      <input
                        type="text"
                        class="form-control"
                        id="price_1001"
                        name="price_1001"
                        value={detail?.price_1001}
                        onChange={onchange}
                      />
                      <div class="input-currency-tag">USD</div>
                    </div>
                  </div>
                  <div className="col-md-12 d-flex justify-content-end align-items-center">
                    <a
                      href="javascript:void(0)"
                      class={`btn btn-brand-color2 text-uppercase btn-block ${loadingUpdate && "button-disabled"}`}
                      onClick={(e) => doSubmit(e)}
                    >
                      {loadingUpdate ? "Please Wait..." : "Save & Next"}
                    </a>
                  </div>
                </form>
              </div>
            </div>
          )}

          {tab === 2 &&
            (optionType === "crop" || optionType === "rotate" ? (
              <div class="offcanvas-dashboard-body">
                <div className="d-flex justify-content-between">
                  <h6>{optionType === "crop" ? "Crop Image" : optionType === "rotate" ? "Rotate Image" : ""}</h6>
                  <button
                    type="button"
                    class="btn-close text-reset"
                    onClick={() => {
                      setOptionType("");
                      setEditedFile([]);
                    }}
                  ></button>
                </div>
                {/* {props.progress === "uploading" ? (
                      <div class="progress-row d-flex align-items-center justify-content-between">
                        <div class="row-progress-label" role="progressbar">
                          Please wait while image is being saved
                        </div>
                      </div>
                    ) : props.progress === "completed" ? (
                      <div class="progress-row d-flex align-items-center justify-content-between">
                        <div class="row-progress-label" role="progressbar">
                          Images has been saved successfully
                        </div>
                      </div>
                    ) : (
                      ""
                    )} */}
                <div
                  class={`offcanvas-widget-row ${
                    optionType === "crop" || (optionType === "rotate" && "padding-top-0")
                  }`}
                >
                  <Edit image={selectedImage} setEditedFile={setEditedFile} ref={childRef} optionType={optionType} />

                  <div class="owr-column-button d-grid gap-2 d-md-flex justify-content-md-end">
                    <button
                      type="button"
                      class="btn btn-brand-color2-outline"
                      onClick={() => {
                        setOptionType("");
                        setEditedFile([]);
                      }}
                    >
                      <span style={{ color: "black" }}> Cancel</span>
                    </button>
                    {optionType === "rotate" && (
                      <button
                        type="button"
                        class="btn btn-default btn-yellow "
                        onClick={() => childRef.current.handleRotate()}
                      >
                        <img src={cropNew} alt="crop" />
                        <span style={{ color: "white", marginLeft: "5px" }}>Rotate</span>
                      </button>
                    )}
                    <button
                      type="button"
                      class={`btn btn-brand-color2 ${loadingMedia ? "disabled" : ""}`}
                      onClick={() => !loadingMedia && handleEditImageUploader()}
                    >
                      {loadingMedia ? "Please Wait" : "Save"}
                    </button>
                  </div>
                </div>

                {/* <div class={`popover-overlay ${showBackdrop && "open"}`}></div> */}
              </div>
            ) : optionType === "scribble" ? (
              <div class="offcanvas-dashboard-body">
                <div className="d-flex justify-content-between">
                  <h6>Scribble Image</h6>
                  <button
                    type="button"
                    class="btn-close text-reset"
                    onClick={() => {
                      setOptionType("");
                      setEditedFile([]);
                    }}
                  ></button>
                </div>

                {/* {props.progress === "uploading" ? (
                      <div class="progress-row d-flex align-items-center justify-content-between">
                        <div class="row-progress-label" role="progressbar">
                          Please wait while image is being saved
                        </div>
                      </div>
                    ) : props.progress === "completed" ? (
                      <div class="progress-row d-flex align-items-center justify-content-between">
                        <div class="row-progress-label" role="progressbar">
                          Image has been saved successfully
                        </div>
                      </div>
                    ) : (
                      ""
                    )} */}
                <div class={`offcanvas-widget-row ${optionType === "scribble" && "padding-top-0"}`}>
                  <Scrib
                    image={selectedImage}
                    setEditedFile={setEditedFile}
                    ref={scribbleRef}
                    handleEditImageUploader={handleEditImageUploader}
                    loadingUpload={loadingMedia}
                  />

                  <div
                    class="owr-column-button d-grid gap-2 d-md-flex justify-content-md-end"
                    style={{ marginRight: "10px" }}
                  >
                    <button
                      type="button"
                      class="btn btn-brand-color2-outline"
                      onClick={() => scribbleRef.current.clear()}
                    >
                      <span style={{ color: "black" }}> Clear</span>
                    </button>

                    <button
                      type="button"
                      class={`btn btn-brand-color2 ${loadingMedia ? "disabled" : ""}`}
                      onClick={() => {
                        scribbleRef.current.handleClick();
                      }}
                    >
                      {loadingMedia ? "Please Wait" : "Save"}
                    </button>
                  </div>
                </div>

                {/* <div class={`popover-overlay ${showBackdrop && "open"}`}></div> */}
              </div>
            ) : (
              <div
                class={`tab-pane fade ${tab === 2 ? "show active" : ""} `}
                id="nav-odt4"
                role="tabpanel"
                aria-labelledby="nav-odt4-tab"
              >
                {/* {progress === "uploading" ? (
                      <div class="progress-row d-flex align-items-center justify-content-between">
                        <div class="row-progress-label" role="progressbar">
                          Please wait while images are being uploaded
                        </div>
                      </div>
                    ) : progress === "completed" ? (
                      <div class="progress-row d-flex align-items-center justify-content-between">
                        <div class="row-progress-label" role="progressbar">
                          Images have been uploaded successfully
                        </div>
                      </div>
                    ) : (
                      ""
                    )} */}
                <div class="offcanvas-dashboard-body">
                  <div class="image-upload-box">
                    <h6>Upload Photographs</h6>
                    <p>
                      Photographs are probably the most important piece of information that buyers are looking for.
                      There is no limit to the number of photgraphs that you can upload. we find the more the
                      photographs the more the bids.
                    </p>
                    <div class="image-upload-input position-relative">
                      <div class="image-upload-input-text text-center">
                        <h6>+ Upload Images</h6>
                        <p>Supported file format : Jpeg, Png</p>
                      </div>
                      <input
                        class="form-control"
                        type="file"
                        multiple
                        accept=".jpg,.jpeg,.png"
                        onChange={(e) => {
                          onSelectMedia(e, "image");
                        }}
                        onClick={(e) => (e.target.value = null)}
                      />
                    </div>
                    <div class="owr-column">
                      {selectedUploadMedia?.img && selectedUploadMedia?.img?.length > 0 ? (
                        <div className="selected-image-parent d-flex flex-wrap">
                          {selectedUploadMedia?.img?.map((item, i) => (
                            <>
                              <div class="selected-image">
                                <img src={`${URL.createObjectURL(selectedUploadMedia?.img[i])}`} alt="" />
                                <a
                                  style={{ cursor: "pointer" }}
                                  class="selected-image-closed"
                                  onClick={() => removeUploaded(selectedUploadMedia?.img[i])}
                                >
                                  <img src={closeIcon} alt="" />
                                </a>
                              </div>
                            </>
                          ))}
                        </div>
                      ) : (
                        ""
                      )}
                    </div>

                    <div class="d-flex justify-content-end mt-4">
                      <a
                        href="javascript:void(0)"
                        class={`btn btn-brand-color2 text-uppercase ${
                          (loadingMedia || selectedUploadMedia?.img?.length === 0) && "button-disabled"
                        }`}
                        onClick={() => onUploadMedia("image")}
                      >
                        {loadingMedia ? "Uploading..." : "Upload"}
                      </a>
                    </div>
                  </div>
                  {detail?.images?.length > 0 && (
                    <>
                      <div class="offcanvas-body-divider"></div>

                      <div class="uploaded-image-container">
                        <h6>All Images</h6>
                        <div class="uploaded-image-list d-flex flex-wrap">
                          {detail?.images &&
                            detail?.images.length > 0 &&
                            detail?.images.map((im, i) => (
                              <div class="uploaded-image-item" style={{ cursor: "pointer" }}>
                                <div class="uploaded-image-box">
                                  <div class="uib-img position-relative">
                                    <img
                                      src={
                                        im.s_path.substring(0, 5) === "https"
                                          ? `${im.s_path}${im.filename}_lp.${im.suffix.toLowerCase()}`
                                          : "https://" +
                                            `${process.env.GATSBY_APP_S3_BUCKET}${im.s_path}${
                                              im.filename
                                            }_lp.${im.suffix.toLowerCase()}`
                                      }
                                      alt={im.filename}
                                    />
                                    <div class="uib-img-title">{im?.caption}</div>
                                  </div>
                                  <div class="uib-icons-list d-flex flex-wrap">
                                    <a
                                      href="javascript:void(0)"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handlePrimayImg(im?.picture_id);
                                      }}
                                      class="uib-icon-box"
                                    >
                                      <img src={im?.picture_id_new ? yellowFeatured : featured} alt="" />
                                    </a>
                                    <OverlayTrigger
                                      trigger="click"
                                      placement="top"
                                      rootClose
                                      overlay={popoverClick}
                                      bsPrefix="show"
                                      onToggle={() => {
                                        if (optionType === "edit") {
                                          setOptionType("");
                                        }
                                      }}
                                    >
                                      <img
                                        src={tag}
                                        className="cursor-pointer"
                                        alt=""
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          if (!loadingMedia) {
                                            setOptionType("edit");
                                            // setShowBackdrop(true);
                                            setTitle(im.caption ? im.caption : "");
                                            setOptionTypeId(im.picture_id);
                                          }
                                        }}
                                      />
                                    </OverlayTrigger>
                                    <a href="javascript:void(0)" class="uib-icon-box">
                                      <img
                                        src={crop}
                                        alt=""
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          setOptionType("crop");
                                          setSelectedImage(im);
                                        }}
                                      />
                                    </a>
                                    <a href="javascript:void(0)" class="uib-icon-box">
                                      <img
                                        src={rotate}
                                        alt=""
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          setOptionType("rotate");
                                          setSelectedImage(im);
                                        }}
                                      />
                                    </a>
                                    <a href="javascript:void(0)" class="uib-icon-box">
                                      <img
                                        src={scribble}
                                        alt=""
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          setOptionType("scribble");
                                          setSelectedImage(im);
                                        }}
                                      />
                                    </a>
                                    <a
                                      href="javascript:void(0)"
                                      class="uib-icon-box"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        e.preventDefault();
                                        setSelectedMedia(im);
                                        toggleDeleteModal();
                                      }}
                                    >
                                      <img src={deleteIcon} alt="" />
                                    </a>
                                  </div>
                                </div>
                              </div>
                            ))}
                        </div>
                      </div>
                    </>
                  )}
                  {/* {progress === "uploading" ? (
                        <div class="progress-row d-flex align-items-center justify-content-between">
                          <div class="row-progress-label" role="progressbar">
                            Please wait while document is being uploaded
                          </div>
                        </div>
                      ) : progress === "completed" ? (
                        <div class="progress-row d-flex align-items-center justify-content-between">
                          <div class="row-progress-label" role="progressbar">
                            Document has been uploaded successfully
                          </div>
                        </div>
                      ) : (
                        ""
                      )} */}
                  <div className="cn-doc-container">
                    <div className="mt-70">
                      <h6>Upload Documents</h6>
                      <p>
                        Please upload any supporting documents, such as bills of lading, materiel safety date sheets,
                        inventory lists, copy of the title, or any other supporting document. Please remove any
                        information that you do not want to be visible to the public like fax numbers the insurer's
                        information or other sensitive information. A Salvex Agent can help you do this if you let them
                        know.
                      </p>
                      <form class="row g-4">
                        <div class="col-md-12">
                          <label class="form-label">
                            Select a File (Only pdf, xlsx, xls, doc, docx and csv formats are supported)
                          </label>
                          <select class="form-select " onChange={(e) => setFileType(e.target.value)}>
                            <option className="doc-option" value=".pdf">
                              PDF
                            </option>
                            <option value=".csv">CSV</option>
                            <option value=".xls">XLS</option>
                            <option value=".xlsx">XLSX</option>
                            <option value=".doc">DOC</option>
                            <option value=".docx">DOCX</option>
                          </select>
                        </div>
                        <div class="col-12">
                          <label for="formFile" class="form-label">
                            Select Document
                          </label>
                          <div class="custom-type-file position-relative d-flex flex-wrap">
                            <div class="ctf-badge d-flex flex-wrap flex-grow-1">
                              <div>
                                {" "}
                                {selectedUploadMedia?.docs &&
                                  selectedUploadMedia?.docs?.length > 0 &&
                                  selectedUploadMedia?.docs[0]?.name}
                                {selectedUploadMedia?.docs && selectedUploadMedia?.docs?.length ? (
                                  <img
                                    class="cross-icon-box"
                                    src={closeIcon}
                                    alt=""
                                    onClick={() =>
                                      setSelectedUploadMedia((prev) => ({
                                        ...prev,
                                        docs: [],
                                      }))
                                    }
                                    style={{ marginLeft: "10px" }}
                                  />
                                ) : (
                                  <p>Please select any document</p>
                                )}
                              </div>
                            </div>
                            <a href="javascript:void(0)" class="ctf-cta flex-shrink-0">
                              Upload
                            </a>
                            <input
                              class="form-control"
                              id="formFile"
                              type="file"
                              accept={`${fileType}`}
                              onChange={(e) => onSelectMedia(e, "doc")}
                              onClick={(e) => (e.target.value = null)}
                            />
                          </div>
                          {error && error?.document ? error?.document : ""}
                        </div>
                        <div class="col-md-12">
                          <label for="inputDocTitle" class="form-label">
                            Document Title
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            id="inputDocTitle"
                            value={docTitle}
                            onChange={(e) => setDocTitle(e.target.value)}
                          />
                          {error && error?.docTitle ? error?.docTitle : ""}
                        </div>
                        <div class="d-flex justify-content-end mt-4">
                          <a
                            href="javascript:void(0)"
                            class={`btn btn-brand-color2 text-uppercase ${
                              (loadingDocs || selectedUploadMedia?.docs?.length === 0 || docTitle?.length === 0) &&
                              "button-disabled"
                            }`}
                            onClick={() => {
                              if (!validateTitle()) {
                                onUploadMedia("doc");
                              }
                            }}
                          >
                            {loadingDocs ? "Uploading..." : "Upload"}
                          </a>
                        </div>
                      </form>

                      {detail?.documents && detail?.documents?.length > 0 && (
                        <>
                          <div class="offcanvas-body-divider"></div>
                          <div class="uploaded-file-container">
                            <h6>All Documents</h6>
                            <div class="uploaded-file-list">
                              {detail?.documents.map((d, i) => (
                                <div class="uploaded-file-item">
                                  <div class="uploaded-file-box d-flex justify-content-between">
                                    <div class="ufb-content d-flex flex-grow-1 space-between align-items-center">
                                      <div class="ufb-content d-flex flex-grow-1">
                                        <div class="ufb-icon d-flex align-items-center">
                                          <img src={pdfIcon} alt="" />
                                        </div>
                                        <div
                                          class="ufb-file-name align-self-center cursor-pointer"
                                          onClick={() =>
                                            window.open(
                                              d.s_path.substring(0, 5) === "https"
                                                ? `${d.filename}`
                                                : `https://${process.env.GATSBY_APP_S3_BUCKET}${d.filename}`,
                                            )
                                          }
                                        >
                                          {d.name}
                                        </div>
                                      </div>
                                      <a
                                        href="javascript:void(0)"
                                        class="uib-icon-box"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          setSelectedMedia(d);
                                          toggleDeleteModal();
                                        }}
                                        style={{ height: "34px" }}
                                      >
                                        <img src={deleteIcon} alt="" />
                                      </a>
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                  <div className="cn-border"></div>
                  <div class="d-flex justify-content-end mt-4">
                    <a
                      href="javascript:void(0)"
                      class={`btn btn-brand-color2 btn-block text-uppercase`}
                      onClick={() => setTab(3)}
                    >
                      Save & Next
                    </a>
                  </div>
                </div>
              </div>
            ))}
          {tab === 3 && (
            <div class=" p-0 cn_body_padding">
              <div class="ovl-content-outer">
                <h5>Product Information</h5>
                <div class="ovl-content d-flex flex-wrap">
                  <div class="ovl-box w-100">
                    <h6>Title</h6>
                    <p>{detail?.title}</p>
                  </div>

                  <div class="ovl-box">
                    <h6>Quantity / Unit</h6>
                    <p>
                      {detail?.quantity ? detail?.quantity : ""} {detail?.unit ? detail?.unit : ""}
                    </p>
                  </div>
                  <div class="ovl-box w-100 ">
                    <h6>Description</h6>
                    <p className="seller-description-scroll sustainability-product-detail-fix dot-list-fix dot-list customized-bullet table-seller-detail">
                      {detail?.details ? HTMLReactParser(detail?.details) : "N/A"}
                    </p>
                  </div>
                  <div class="ovl-box">
                    <h6>Deadline</h6>
                    <p>{detail?.end_time}</p>
                  </div>

                  <div class="ovl-box w-100">
                    <h6>Condition</h6>
                    <p>
                      {" "}
                      {detail?.conditionType?.name
                        ? detail?.conditionType?.name == "Others"
                          ? otherCondition
                          : detail?.conditionType?.name
                        : ""}
                    </p>
                  </div>
                  <div class="ovl-box w-100">
                    <h6>Condition Description</h6>
                    {detail?.condition ? HTMLReactParser(detail?.condition) : ""}
                  </div>
                </div>
              </div>
              <div class="ovl-content-outer">
                <h5>Product Location</h5>
                <div class="ovl-content d-flex flex-wrap">
                  <div class="ovl-box">
                    <h6>Contact</h6>
                    <p>{detail?.c_name || ""}</p>
                  </div>
                  <div class="ovl-box">
                    <h6>Company</h6>
                    <p>{detail?.c_company || ""}</p>
                  </div>
                  <div class="ovl-box">
                    <h6>Phone</h6>
                    <p>{detail?.c_phone || ""}</p>
                  </div>
                  <div class="ovl-box">
                    <h6>Fax</h6>
                    <p>{detail?.c_fax || ""}</p>
                  </div>{" "}
                  <div class="ovl-box">
                    <h6>Email</h6>
                    <p>{detail?.c_email || ""}</p>
                  </div>
                  <div class="ovl-box">
                    <h6>Address</h6>
                    <p>{detail?.address_1 || ""}</p>
                  </div>{" "}
                  <div class="ovl-box">
                    <h6>City</h6>
                    <p>{detail?.city || ""}</p>
                  </div>
                  <div class="ovl-box">
                    <h6>Zip</h6>
                    <p>{detail?.zip || ""}</p>
                  </div>
                  <div class="ovl-box">
                    <h6>State</h6>
                    <p>{detail?.state?.name || ""}</p>
                  </div>
                  <div class="ovl-box">
                    <h6>Country</h6>
                    <p>{detail?.country?.name || ""}</p>
                  </div>
                </div>
              </div>
              <div class="ovl-content-outer">
                <h5>Product Pricing and Reserve</h5>
                <div class="ovl-content d-flex flex-wrap">
                  <div class="ovl-box">
                    <h6>Wholesale Value</h6>
                    <p>{detail?.price_1003 ? "$" + numberFormat(detail?.price_1003) : ""}</p>
                  </div>
                  <div class="ovl-box">
                    <h6>Retail Value</h6>
                    <p>{detail?.price_1002 ? "$" + numberFormat(detail?.price_1002) : ""}</p>
                  </div>
                  <div class="ovl-box">
                    <h6>Claim Price</h6>
                    <p>{detail?.price_1004 ? "$" + numberFormat(detail?.price_1004) : ""}</p>
                  </div>
                  <div class="ovl-box">
                    <h6>Reserve Price</h6>
                    <p>{detail?.price_1001 ? "$" + numberFormat(detail?.price_1001) : ""}</p>
                  </div>
                </div>
              </div>

              <div class="ovl-content-outer">
                <h5>Photographs</h5>
                <div class=" d-flex flex-wrap">
                  {detail?.images?.length > 0 ? (
                    detail?.images?.map((ep) => (
                      <div class="uploaded-image-item">
                        <div class="uploaded-image-box">
                          <div class="uib-img position-relative">
                            {ep?.s_path.substring(0, 5) === "https" ? (
                              <img src={`${ep.s_path}${ep.filename}_lp.${ep.suffix}`} alt={ep?.filename} />
                            ) : (
                              <img
                                src={`${process.env.GATSBY_MEDIA_URL}${ep?.s_path}${ep?.filename}_lp.${ep?.suffix}`}
                                alt={ep?.filename}
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div class="ovl-content d-flex flex-wrap">
                      <div class="ovl-box">
                        <p className="gray-text">No Images were added</p>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <div class="ovl-content-outer">
                <h5>Documents</h5>
                <div class="uploaded-file-list">
                  {detail?.documents?.length > 0 ? (
                    detail &&
                    detail.documents &&
                    detail.documents.length > 0 &&
                    detail.documents.map((f, i) => (
                      <div
                        class="uploaded-file-item"
                        onClick={() => window.open(process.env.GATSBY_MEDIA_URL + f.filename)}
                      >
                        <div class="uploaded-file-box d-flex justify-content-between">
                          <div class="ufb-content d-flex flex-grow-1">
                            <div class="ufb-icon d-flex align-items-center">
                              <img
                                class="ufb-icon"
                                style={{ width: "24px", height: "24px" }}
                                src={pdfIcon}
                                alt="docfileImg"
                              />
                            </div>
                            <div
                              class="ufb-file-name align-self-center cursor-pointer"
                              onClick={() =>
                                window.open(
                                  f?.s_path.substring(0, 5) === "https"
                                    ? `${f?.filename}`
                                    : `https://${process.env.GATSBY_APP_S3_BUCKET}${f?.filename}`,
                                )
                              }
                            >
                              {f.name}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div class="ovl-content d-flex flex-wrap">
                      <div class="ovl-box">
                        <p className="gray-text">No Documents were added</p>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div class="d-flex justify-content-end mt-4">
                <a
                  href="javascript:void(0)"
                  class={`btn btn-brand-color2 btn-block text-uppercase`}
                  onClick={() => {
                    if (
                      props?.deploy === "buyer_management" ||
                      props?.deploy === "escrow_service" ||
                      props?.deploy === "marketing_push"
                    ) {
                      props?.setIsPostCreate(false);
                      props?.setIsDashboard(true);
                      props?.setNext(false);
                      // props?.handleAddTask();
                    } else {
                      props?.setIsPostCreate(false);
                      props?.setIsDashboard(true);
                    }
                  }}
                >
                  {props?.deploy === "buyer_management" ||
                  props?.deploy === "escrow_service" ||
                  props?.deploy === "marketing_push"
                    ? "Submit"
                    : "Save & Next"}
                </a>
              </div>
            </div>
          )}
        </div>
        <div class={`popover-overlay ${optionType === "edit" || optionType === "delete" ? "open " : ""}`}></div>
      </div>
      <DeleteModal
        show={deleteModal}
        handleClose={() => toggleDeleteModal()}
        message={"Are you sure you want to delete?"}
        loading={loadingMedia}
        handleDelete={selectedMedia?.picture_id ? handleDeleteImg : handleDeleteDoc}
      />
    </>
  );
};

export default React.memo(CreateListing);
